// RTK Query slice for the PMS Chatbot service (separate FastAPI backend, see REACT_APP_CHATBOT_API_BASE_URL).
// Kept isolated from `logdetailSlice` (the main PMS api) since it targets a different host.
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const chatbotApiSlice = createApi({
  reducerPath: "chatbotApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_CHATBOT_API_BASE_URL,
  }),
  endpoints: (builder) => ({
    sendChatMessage: builder.mutation({
      // body: { query: string, user_id: number, role: string }
      query: (body) => ({
        url: "chat",
        method: "POST",
        body,
      }),
    }),
    confirmChatEntity: builder.mutation({
      // body: { session_id, entity_type, entity_id, entity_name }
      query: (body) => ({
        url: "chat/confirm",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useSendChatMessageMutation, useConfirmChatEntityMutation } =
  chatbotApiSlice;
export default chatbotApiSlice;
